module.exports = __webpack_public_path__ + "img/atm-pc.e6b74d14.svg";